import React from "react";
var __jsx = React.createElement;
/** @format */

import { useState } from "react";
import stl from "./FinanceOfferDetails.module.css";
import ArrowDownSVG from "../../../../../../../SVGObjects/UiKit/ArrowDownSVG";
import { useTranslation } from "@i18n";
var FinanceOfferDetails = function FinanceOfferDetails(_ref) {
  var _details$, _details$2, _headDetails$car_deta, _headDetails$car_deta2;
  var headDetails = _ref.headDetails,
    details = _ref.details;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showData = _useState[0],
    setSetShowData = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.innerContainerTm, showData ? stl.removeFixed : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.headContr, " ").concat(details ? stl.pointer : ""),
    onClick: function onClick() {
      setSetShowData(!showData);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.headData
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.title
  }, details ? (_details$ = details[0]) === null || _details$ === void 0 ? void 0 : _details$.title : headDetails === null || headDetails === void 0 ? void 0 : headDetails.title), /*#__PURE__*/React.createElement("p", {
    className: stl.value
  }, details ? (_details$2 = details[0]) === null || _details$2 === void 0 ? void 0 : _details$2.value : headDetails === null || headDetails === void 0 ? void 0 : headDetails.value)), details && /*#__PURE__*/React.createElement("div", {
    className: stl.flxRow
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.title
  }, t("financing_offer_details", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement(ArrowDownSVG, {
    className: "".concat(!showData ? stl.rotateArrow : "", " ").concat(stl.transition)
  }))), details && showData ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.imgContainer
  }, /*#__PURE__*/React.createElement("strong", null, t("details_financing_offer_syarah", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.imgTm
  }, /*#__PURE__*/React.createElement("img", {
    width: "90px",
    height: "67px",
    src: headDetails === null || headDetails === void 0 ? void 0 : (_headDetails$car_deta = headDetails.car_details) === null || _headDetails$car_deta === void 0 ? void 0 : _headDetails$car_deta.image,
    alt: "car"
  }), /*#__PURE__*/React.createElement("strong", null, headDetails === null || headDetails === void 0 ? void 0 : (_headDetails$car_deta2 = headDetails.car_details) === null || _headDetails$car_deta2 === void 0 ? void 0 : _headDetails$car_deta2.title))), details === null || details === void 0 ? void 0 : details.map(function (detail, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "".concat(stl.rowTm, " ").concat(idx === 0 ? stl.bankTm : "")
    }, /*#__PURE__*/React.createElement("span", null, detail === null || detail === void 0 ? void 0 : detail.title), /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("span", null, detail === null || detail === void 0 ? void 0 : detail.value, /*#__PURE__*/React.createElement("span", null, detail === null || detail === void 0 ? void 0 : detail.text_value))));
  })) : ""));
};
export default FinanceOfferDetails;